import { Component, lazy } from 'solid-js';
import { Router, Route } from '@solidjs/router';
import { QueryClient, QueryClientProvider } from '@tanstack/solid-query';

import './main.css';

const Dashboard = lazy(() => import('./routes/Dashboard'));

/**
 * QueryClient с разумными дефолтами для self-service portal:
 *  - peers редко меняются → staleTime 30s
 *  - refetchOnWindowFocus оставляем true, чтобы после OIDC-redirect видеть
 *    свежие peers без F5
 *  - retry: 1 — 401 уже хендлится в `api/client.ts` (redirect на /login),
 *    остальные 4xx ретраить не надо
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const App: Component = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Route path="/" component={Dashboard} />
      </Router>
    </QueryClientProvider>
  );
};

export default App;
